import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Store/StoreLocatorMobile/storeLocatorMobile.container"
    ).then((module) => ({
        default: module.StoreLocatorMobileContainer
    }))
);
